"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const InfoIcon = (_a) => {
    var { stroke = ui_components_1.baseColors.primaryBlueAccent700 } = _a, props = __rest(_a, ["stroke"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("rect", { x: "1.16663", y: "1.16602", width: "11.6667", height: "11.6667", rx: "5.83333", stroke: stroke, strokeWidth: "0.875" }), react_1.default.createElement("path", { d: "M7.29163 9.91602L7.29163 6.41602", stroke: stroke, strokeWidth: "0.875", strokeLinecap: "round", strokeLinejoin: "round" }), react_1.default.createElement("path", { d: "M6.12496 6.41602L7.29163 6.41602", stroke: stroke, strokeWidth: "0.875", strokeLinecap: "round", strokeLinejoin: "round" }), react_1.default.createElement("path", { d: "M7.29163 4.66634L7.29163 4.08301", stroke: stroke, strokeWidth: "0.875", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = InfoIcon;
